var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 380,
    viewBox: "0 0 428 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321 0H107L0 190.016L107 380H321L428 190.016L321 0ZM279.614 306.541H148.376L82.7621 190.016L148.376 73.4806H279.614L345.238 190.016L279.614 306.541Z",
    fill: "#D9D889",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureYellow);
export default __webpack_public_path__ + "static/media/figure_yellow.8dd42fdffe1ed4bcc4e8de3d5d3c706f.svg";
export { ForwardRef as ReactComponent };